// httpLink の fetch 試行で採番した requestId (X-REQUEST-ID ヘッダ) を、
// 唯一の通知点である errorLink まで Error に載せて引き継ぐためのヘルパー。
// これにより BugSnag の ApolloClientNetworkError からサーバーログを requestId で追跡できる。
type ErrorWithRequestId = Error & { salescoreRequestId: string }

// Error は throw で伝播する性質上、新しい Error にラップすると name/message/stack を失い
// errorLink 側の通知内容が変わってしまうため、元の Error にプロパティを付与して引き継ぐ。
export const attachRequestId = (error: Error, requestId: string): ErrorWithRequestId =>
  Object.assign(error, { salescoreRequestId: requestId })

const hasRequestId = (error: Error): error is ErrorWithRequestId =>
  'salescoreRequestId' in error && typeof error.salescoreRequestId === 'string'

export const getRequestId = (error: unknown): string | undefined =>
  error instanceof Error && hasRequestId(error) ? error.salescoreRequestId : undefined
